/**
 * Carbon Plugin 공통 코드 모듈
 * API 기반, Vuex 미사용
 */
import CarbonCodes from "./carbonCodes";
import { FIELD_TO_GROUP } from "./carbonCodes";

export default CarbonCodes;
export { CarbonCodes, FIELD_TO_GROUP };

